import { StrategyType } from "@/lib/interfaces and Enums/ENUMStrategyType";
import { StructureTypeCode } from "@/lib/interfaces and Enums/ENUMStructureTypeCode";
import { TradeType } from "@/lib/interfaces and Enums/ENUMTradeType";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import quoteSnapshotStore, {
  IQuoteSidesSnapshot,
  IQuoteSnapshot,
} from "./quoteSnapshotStore";

export function buildQuoteSnapshot(trade: ExecutionStrategy): IQuoteSnapshot {
  const blocks: Record<number, IQuoteSidesSnapshot> = {};
  trade.legs?.forEach((leg) => {
    if (leg.blockId == null) return;
    blocks[leg.blockId] = { bid: leg.bid, ask: leg.ask };
  });

  const firstLeg = trade.legs?.[0];
  const isOutright = trade.strategyType == StrategyType.Outright;
  return {
    bid: isOutright ? firstLeg?.bid : trade.bid,
    ask: isOutright ? firstLeg?.ask : trade.ask,
    blocks,
  };
}

export function isSynRepo(trade: ExecutionStrategy): boolean {
  return (
    trade.structureType == StructureTypeCode.SYNREPO ||
    trade.structureType == StructureTypeCode.SYNREVREP
  );
}

// Only RP RFQs can lock: Orders are edited via fills and the OP never quotes.
// SYN repos are exempt: leg quotes first appear at Awarded and must reopen after an executed change request.
export function buildQuoteSnapshots(
  trades: ExecutionStrategy[],
): Record<string, IQuoteSnapshot> {
  const snapshots: Record<string, IQuoteSnapshot> = {};
  trades.forEach((trade) => {
    if (trade.role !== "RP" || trade.type == TradeType.Order) return;
    if (isSynRepo(trade)) return;
    snapshots[trade.esid] = buildQuoteSnapshot(trade);
  });
  return snapshots;
}

// Call only with server responses, before they reach tradeData.
export function recordServerQuoteSnapshots(
  trades: ExecutionStrategy[],
  replaceAll = false,
) {
  const snapshots = buildQuoteSnapshots(trades);
  if (replaceAll) {
    quoteSnapshotStore.getState().replaceQuoteSnapshots(snapshots);
  } else {
    quoteSnapshotStore.getState().mergeQuoteSnapshots(snapshots);
  }
}
